import BasePasswordField from 'registration/js/base/fields/password';

import template from 'registration/templates/new/fields/password.html';

const PasswordField = BasePasswordField.extend({
    template
});

export default PasswordField;
